var React = require('react');

function Folder (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.112 8.829a.3.3 0 01-.3-.3V3.807A1.2 1.2 0 012.01 2.61h3.295a.3.3 0 01.211.088l1.11 1.11h5.567c.503 0 .956.321 1.125.798a.3.3 0 01-.282.4H3.807c-.819 0-1.533.553-1.738 1.345l-.002.01-.668 2.254a.3.3 0 01-.287.215zm2.695-3.225H13.99c.66 0 1.197.537 1.197 1.198 0 .103-.015.207-.046.318a.303.303 0 01-.012.052l-1.78 5.33a1.194 1.194 0 01-1.156.888H2.01c-.49 0-.927-.295-1.11-.753a.3.3 0 01-.01-.196l1.754-5.92.002-.006a1.19 1.19 0 011.161-.91z"}));
}

Folder.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Folder;

Folder.default = Folder;
